import PropTypes from 'prop-types';
import ABBPropTypes from 'airbnb-prop-types';
import { variantProp, getTokensPropType } from '../utils/props';
import A11yText from '../A11yText';
import { iconComponentPropTypes } from '../Icon';
export const textAndA11yText = ABBPropTypes.childrenOf(PropTypes.oneOfType([ABBPropTypes.elementType(A11yText), PropTypes.string]));
const buttonPropTypes = {
  tokens: getTokensPropType('Button'),
  /**
   * If true, prevents the button from being pressed, changes the cursor (on web) and accessibility
   * attributes to communicate this to the user, and applies `inactive: true` appearances from the theme
   */
  inactive: PropTypes.bool,
  /**
   * Alias for `inactive`
   */
  disabled: PropTypes.bool,
  /**
   * Button's children must be either:
   *  - One or more text strings and / or A11yText components
   *  - A render function with contents that responds to current button state by being passed an object of:
   * ```
   * { hovered<bool>, focused<bool>, pressed<bool>, inactive<bool>, selected<bool>, textStyles<RNStyle> }
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func, textAndA11yText]).isRequired,
  /**
   * Function called when the button is pressed. Required unless the button has a href.
   */
  onPress: PropTypes.func,
  /**
   * Optional variant that may be passed down to the link's icon if there is one
   */
  iconProps: PropTypes.exact(iconComponentPropTypes),
  /**
   * When `icon` is provided, use `iconPosition` to place the Icon to the left or right side of the button.
   */
  iconPosition: PropTypes.oneOf(['left', 'right']),
  /**
   * A function component for an SVG icon to render inside the link. Inherits size and color from
   * the link and any Typography the link is nested inside.
   */
  icon: PropTypes.func,
  variant: variantProp.propType
};
export default buttonPropTypes;